import { isAndroid, isIOS, isInsideAPP } from "./platforms"
import { Toast } from "antd-mobile"
import config from "../config/env"

// js 原生交互代码
function connectWebViewJavascriptBridge(callback) {
  if (window.WebViewJavascriptBridge) {
    callback(window.WebViewJavascriptBridge)
  } else {
    document.addEventListener(
      "WebViewJavascriptBridgeReady",
      function () {
        callback(window.WebViewJavascriptBridge)
      },
      false
    )
    if (!isAndroid) {
      if (window.WebViewJavascriptBridge) {
        return callback(window.WebViewJavascriptBridge)
      }
      if (window.WVJBCallbacks) {
        return window.WVJBCallbacks.push(callback)
      }
      window.WVJBCallbacks = [callback]
      const WVJBIframe = document.createElement("iframe")
      WVJBIframe.style.display = "none"
      WVJBIframe.src = "https://__bridge_loaded__"
      document.documentElement.appendChild(WVJBIframe)
      setTimeout(function () {
        document.documentElement.removeChild(WVJBIframe)
      }, 0)
    }
  }
}

// 初始化 ios接受 token
connectWebViewJavascriptBridge(function (bridge) {
  bridge.registerHandler("callRefreshAccessToken", function (data, cb) {
    updateSessionInfo(data)
  })
})
// ios 处理err
connectWebViewJavascriptBridge(function (bridge) {
  bridge.registerHandler("accessTokenError", function (data, cb) {})
})

// ios 分享返回炼金术
connectWebViewJavascriptBridge(function (bridge) {
  bridge.registerHandler("appShareCallBackH5", function (data, cb) {
    Toast.info("分享成功")
  })
})

// android 分享返回炼金术
window.appShareCallBackH5 = function () {
  Toast.info("分享成功")
}

// go to login
function goNativeLogin(data = 1) {
  const params = JSON.stringify({ loginType: data })
  if (isAndroid) {
    try {
      window.CgwsH5JS.login(params)
    } catch (e) {
      console.log(e.message)
    }
  } else if (isIOS) {
    connectWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler("login", params, function (response) {})
    })
  }
  // recieve data
  window.callRefreshAccessToken = function (data) {
    // 获取原生传递的token 信息
    updateSessionInfo(data)
  }
  // recieve err
  window.accessTokenError = function () {}
}

// get sessionid/access_token
function getAccessToken() {
  if (isAndroid) {
    try {
      const data = window.CgwsH5JS.getAccessToken()
      updateSessionInfo(data)
    } catch (e) {
      console.log(e.message)
    }
  } else if (isIOS) {
    connectWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler("getAccessToken", 1, function (data) {
        updateSessionInfo(data)
      })
    })
  }
}

// settitle
function setTitle(pathname) {
  console.log("pathname")
  console.log(pathname)
  const title = pathname === "/myprize" ? "我的奖品" : "金哥宝箱，助您战“疫”"
  if (isAndroid) {
    try {
      window.CgwsH5JS.setTitle(JSON.stringify({ title }))
    } catch (error) {
      console.log(error.message)
    }
  } else {
    connectWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler("setiOSTitle", JSON.stringify({ title }), function () {
        // fn && fn();
      })
    })
  }
}

// 退出webView
function exitWebView() {
  if (isAndroid) {
    try {
      window.CgwsH5JS.exitWebView()
    } catch (e) {
      console.log(e.message)
    }
  } else if (isIOS) {
    connectWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler("exitWebView", "", function () {
        // fn && fn();
      })
    })
  }
}

// 刷新webView
function refreshWebView() {
  if (isAndroid) {
    try {
      window.CgwsH5JS.refreshWebView()
    } catch (e) {
      console.log(e.message)
    }
  } else if (isIOS) {
    connectWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler("refreshWebView", "", function () {
        // fn && fn();
      })
    })
  }
}

//更新session信息
const updateSessionInfo = (data) => {
  const userInfo = JSON.parse(data)

  if (userInfo.access_token && userInfo.access_token.length) {
    sessionStorage.setItem("userInfo", data)
    window.cb.loginSuccess()
  } else {
    goNativeLogin()
  }
}

// 跳转查看账单
function login(shareId) {
  // app内
  if (isInsideAPP) {
    goNativeLogin()
  }
  //app外
  else {
    window.location.href =
      shareId.length !== 0
        ? config.IOS_DOWNLOAD_OR_OPEN_APP + `%3FshareId%3D${shareId}`
        : config.IOS_DOWNLOAD_OR_OPEN_APP
  }
}

//微信分享链接
function connectAppShare(shareId) {
  const obj = JSON.stringify({
    title: config.title,
    content: config.content,
    httpUrl: config.httpUrl + `?shareId=${shareId}`,
    imgUrl: config.imageUrl,
  })
  if (isAndroid) {
    window.CgwsH5JS.commonShare(obj)
  } else {
    connectWebViewJavascriptBridge(function (bridge) {
      bridge.callHandler("commonShare", obj, function () {})
    })
  }
}

export {
  goNativeLogin,
  refreshWebView,
  exitWebView,
  getAccessToken,
  login,
  connectAppShare,
  setTitle,
}
